export const REGION_US_FLAG = '🇺🇸';
export const REGION_US_CODE = 'US';
export const REGION_JP_FLAG = '🇯🇵';
export const REGION_JP_CODE = 'JP';
